<script setup lang="ts">
import RichTextField from '@/components/common/RichTextField.vue';
import { ref } from 'vue';

const props = defineProps({
  text: { type: String, required: true, default: () => '' },
  styles: { type: String, default: () => '' },
});
const text = ref<string>(props.text || '');
const isActive = ref<boolean>(false);

const emit = defineEmits(['change']);

const change = () => {
  emit('change', text.value);
};
</script>
<template>
  <div class="small-rich-text">
    <v-btn
      icon="mdi-pencil-outline"
      :style="styles"
      density="compact"
      @click="isActive = true"
    ></v-btn>
    <div style="margin: 8" class="modal" v-if="isActive">
      <v-card title="Edit the field">
        <RichTextField
          label="Text"
          :height="180"
          style="max-height: 300px"
          v-model="text"
          @change="change"
        />

        <v-btn
          class="save-button"
          @click="
            () => {
              isActive = false;
              change();
            }
          "
          >Save</v-btn
        >
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.modal {
  position: relative;
  width: 500px;
  height: 300px;
  padding: 8px;
  margin-bottom: 4px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 2px 2px 4px silver;
}

.save-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
